import { ColorPickerColors, ColorPickerColorsMap } from '../models/ColorPicker';

class ColorUtils {
  static convert(value: string): string {
    console.log('ColorUtils.convert', value);

    if (value === 'default' || value === '#transparent') {
      return 'transparent';
    }

    return ColorPickerColorsMap[value as ColorPickerColors] || value;
  }
}

export default ColorUtils;
